import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Input from '../../input';
import { toHexFormat } from '../color';
import { generateColor } from '../util';
var hexReg = /(^#[\da-f]{6}$)|(^#[\da-f]{8}$)/i;

var isHexString = function isHexString(hex) {
  return hexReg.test("#".concat(hex));
};

var ColorHexInput = function ColorHexInput(_ref) {
  var prefixCls = _ref.prefixCls,
      value = _ref.value,
      onChange = _ref.onChange;
  var colorHexInputPrefixCls = "".concat(prefixCls, "-hex-input");

  var _useState = useState(value === null || value === void 0 ? void 0 : value.toHex()),
      _useState2 = _slicedToArray(_useState, 2),
      hexValue = _useState2[0],
      setHexValue = _useState2[1]; // Update step value


  useEffect(function () {
    var hex = value === null || value === void 0 ? void 0 : value.toHex();

    if (isHexString(hex) && value) {
      setHexValue(toHexFormat(hex));
    }
  }, [value]);

  var handleHexChange = function handleHexChange(e) {
    var originValue = e.target.value;
    setHexValue(toHexFormat(originValue));

    if (isHexString(toHexFormat(originValue, true))) {
      onChange === null || onChange === void 0 ? void 0 : onChange(generateColor(originValue));
    }
  };

  return /*#__PURE__*/React.createElement(Input, {
    className: colorHexInputPrefixCls,
    value: hexValue === null || hexValue === void 0 ? void 0 : hexValue.toUpperCase(),
    prefix: "#",
    onChange: handleHexChange,
    size: "small"
  });
};

export default ColorHexInput;